const hasValue = value => value !== undefined && value !== null && value !== ''

export const DEFAULT_WORK_FLOW_GRID_HEIGHT = 260
export const WORK_FLOW_GRID_HEIGHT_STORAGE_KEY = 'work-management:flow-grid-height'

export function normalizeStoredWorkFlowGridHeight(value) {
  if (!hasValue(value)) return DEFAULT_WORK_FLOW_GRID_HEIGHT
  const height = Number(value)
  return Number.isFinite(height) && height >= 0 ? height : DEFAULT_WORK_FLOW_GRID_HEIGHT
}

export function toggleFlowWorkItemId(currentItemId, nextItemId) {
  if (!hasValue(nextItemId)) return null
  if (hasValue(currentItemId) && String(currentItemId) === String(nextItemId)) return null
  return nextItemId
}

export function resolveWorkFlowSplit({
  containerHeight,
  handleHeight = 10,
  startGridHeight = DEFAULT_WORK_FLOW_GRID_HEIGHT,
  pointerDelta = 0,
} = {}) {
  const safeContainerHeight = Math.max(0, Number(containerHeight) || 0)
  const safeHandleHeight = Math.min(safeContainerHeight, Math.max(0, Number(handleHeight) || 0))
  const availableHeight = safeContainerHeight - safeHandleHeight
  const normalizedGridHeight = normalizeStoredWorkFlowGridHeight(startGridHeight)
  const requestedGridHeight = normalizedGridHeight + (Number(pointerDelta) || 0)
  const gridHeight = Math.min(availableHeight, Math.max(0, requestedGridHeight))
  return {
    gridHeight,
    handleHeight: safeHandleHeight,
    detailHeight: availableHeight - gridHeight,
  }
}

export function workItemFlowLocation({ projectId, workId, workItemId } = {}) {
  if (![projectId, workId, workItemId].every(hasValue)) return null
  return {
    name: 'WorkDetail',
    params: { pk: projectId, work_id: workId },
    query: { tab: 'flow', item_id: workItemId },
  }
}

export function workItemFlowPath(context = {}) {
  const location = workItemFlowLocation(context)
  if (!location) return null
  return `/work-management/${encodeURIComponent(location.params.pk)}/works/${encodeURIComponent(location.params.work_id)}?tab=flow&item_id=${encodeURIComponent(location.query.item_id)}`
}
